import Luminous, {LuminousGallery} from 'luminous-lightbox';
import Swiper, {Navigation, Autoplay} from "swiper";

Swiper.use([Navigation, Autoplay]);

export default class Park {

    constructor() {
        if (document.querySelector('.page-park')) {
            // this.tabs();
            // this.initIframes();
            this.luminous();
            this.initReviews();
            this.photoSlider();
            this.parkSlider();
        }
    }

    photoSlider() {
        if(!document.querySelector('#photoSlider')) return;
        new Swiper('#photoSlider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 20,
            autoplay: {
                delay: 3000,
            },
            navigation: {
                nextEl: '.photos .controls .swiper-button-next',
                prevEl: '.photos .controls .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }
            }
        });
    }

    parkSlider() {
        if(!document.querySelector('#parkSlider')) return;
        new Swiper('#parkSlider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 20,
            autoplay: {
                delay: 3000,
            },
            navigation: {
                nextEl: '.parks .controls .swiper-button-next',
                prevEl: '.parks .controls .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }
            }
        });
    }

    tabs() {
        const tabs = document.querySelectorAll('#tabsWrapper .tab');
        const values = document.querySelectorAll('.tab-value');
        tabs[0].classList.add('active');
        values[0].classList.add('active');
        tabs.forEach(function (tab, i) {
            tab.addEventListener('click', function (ev) {
                ev.preventDefault();

                values.forEach(function (value) {
                    value.classList.remove('active');
                });

                tabs.forEach(function (link) {
                    link.classList.remove('active');
                });

                let item = document.querySelector(tab.getAttribute('href'));
                this.classList.add('active');
                item.classList.add('active');
            });
        })
    }

    initIframes() {
        const tabOmschrijving = document.getElementById('tabOmschrijving');
        tabOmschrijving.querySelectorAll('iframe').forEach(function (el) {
            let iframeWrapper = document.createElement('div')
            iframeWrapper.classList.add('iframe-wrapper');
            el.parentNode.insertBefore(iframeWrapper, el);
            iframeWrapper.appendChild(el);
        });
    }

    luminous() {
        new LuminousGallery(document.querySelectorAll('.page-park .luminous'));
    }

    initReviews() {
        new Swiper('#reviews .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 60,
            navigation: {
                nextEl: '#reviews .swiper-button-next',
                prevEl: '#reviews .swiper-button-prev',
            }
        });
    }
}
